// extracted by mini-css-extract-plugin
export default {"container":"Ho-z","bubbleNav":"Io-z","graphic":"Jo-z","contact":"Ko-z"};